var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEclipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 174.511719 150 C 174.511719 187.609375 144.023438 218.101563 106.414063 218.101563 C 68.800781 218.101563 38.3125 187.609375 38.3125 150 C 38.3125 112.390625 68.800781 81.898438 106.414063 81.898438 C 144.023438 81.898438 174.511719 112.390625 174.511719 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 152.726563 41.039063 C 125.117188 41.039063 99.921875 51.328125 80.722656 68.257813 C 93.710938 61.320313 108.535156 57.375 124.289063 57.375 C 175.445313 57.375 216.914063 98.847656 216.914063 150 C 216.914063 201.15625 175.445313 242.625 124.289063 242.625 C 108.535156 242.625 93.710938 238.679688 80.722656 231.742188 C 99.921875 248.671875 125.117188 258.960938 152.726563 258.960938 C 212.902344 258.960938 261.6875 210.175781 261.6875 150 C 261.6875 89.824219 212.902344 41.039063 152.726563 41.039063 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse);
export default __webpack_public_path__ + "static/media/Eclipse.525c818f8fac3fda9b06d429bb5f10fb.svg";
export { ForwardRef as ReactComponent };